import React from "react";
import { Checkbox, Switch } from "@fluentui/react-components";
import type { CheckboxOnChangeData, SwitchOnChangeData } from "@fluentui/react-components";
import styles from "./checkBox.module.scss";

interface CheckBoxProps {
    label?: string;
    isChecked: boolean;
    iconComponent?: React.ReactNode;
    toggle?: boolean;
    disabled?: boolean;

    handleDataChange: (value: boolean) => void;
}

const CheckBox: React.FC<CheckBoxProps> = (props: CheckBoxProps) => {
    const { isChecked, iconComponent, handleDataChange, toggle, disabled, label } = props;

    const handleCheckboxChange = (_: React.ChangeEvent<HTMLInputElement>, data: CheckboxOnChangeData) => {
        handleDataChange(data.checked === true);
    };

    const handleSwitchChange = (_: React.ChangeEvent<HTMLInputElement>, data: SwitchOnChangeData) => {
        handleDataChange(data.checked);
    };

    return (
        <div className={styles.checkBoxWrapper}>
            <div className={styles.iconComponent}>{iconComponent}</div>
            {toggle ? (
                <Switch checked={isChecked} onChange={handleSwitchChange} label={label} disabled={disabled} />
            ) : (
                <Checkbox checked={isChecked} onChange={handleCheckboxChange} label={label} disabled={disabled} />
            )}
        </div>
    );
};

export default CheckBox;
